import { VH, VW } from "../../tiles";
import { Scene } from "../../ui/scene";
import { createElement } from "../../ui/ui";
import { HomeComponent } from "../ui/home/homeComponent";

export class Main extends Scene {
  ui = createElement(HomeComponent, { x: 0, y: 0, w: VW, h: VH });
}
